module.exports = __webpack_public_path__ + "static/img/p3_1.e935edf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/product/p3_1.png
// module id = dnGh
// module chunks = 1